import React from "react";
import Container from "@/components/marketing/Container";
import HeroBackground from "@/components/marketing/HeroBackground";

export default function PackagesHero() {
  return (
    <section className="relative overflow-hidden pt-28 lg:pt-32 pb-14 sm:pb-16 lg:pb-20 text-center">
      <HeroBackground />
      <Container className="relative">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6d28d9] mb-4">
          Curated Packages
        </div>
        <h1 className="font-heading text-[clamp(36px,5vw,56px)] font-[650] tracking-[-0.03em] leading-[1.06] mb-5 max-w-3xl mx-auto text-heading-gradient">
          The mix is already figured out.
        </h1>
        <p className="text-[16px] lg:text-[17px] leading-[1.55] text-[#6c6c74] max-w-[560px] mx-auto">
          Packages built by our in-house PR team, specialists who have run campaigns across finance, tech, crypto, and lifestyle for years. Each one is put together around a sector, a region, or a goal, and priced below buying the channels separately.
        </p>
      </Container>
    </section>
  );
}